import React from 'react'
import "./Order_Cancel_Details_Table.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { Form, Table } from 'react-bootstrap'
import { IDS } from '../../../../../../utils/IDS'

function Order_Cancel_Details_Table({ dontShowPrice, showCheck = false, product, selectedItems,
  setSelectedItems,
  setError, }) {
  const handleCheckboxChange = (val) => {
    setError("");
    setSelectedItems((prev) => {
      const exists = prev.some((item) => item.id === val.id); // use a unique ID or index
      if (exists) {
        return prev.filter((item) => item.id !== val.id);
      } else {
        return [...prev, val]; // or just store val.id if needed
      }
    });
  };
  return (
    <>
      <div className='product_content_holder'>
        <div className='product_content'>
          {/* {products?.map((product) => ( */}
          <div className='product_detail_inner'>
            <div className='left_side'>
              {
                showCheck &&
                <Form.Check type={"checkbox"} className="cancel_check"
                  checked={selectedItems?.some((item) => item.id === product.id)}
                  onChange={() => handleCheckboxChange(product)} />
              }
              <div className='img_holder'>
                <img
                  src={IDS.IMG_URL + product?.Product?.image}
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>{product?.Product?.name || " "}</p>
                </div>
                {/* <div className='weight'>
                  <p>(5 Faces)</p>
                </div> */}
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x {product?.quantity || "0"} {!dontShowPrice && <span className='price'>₹{Number(product?.Product?.price).toFixed(2) || "0"}</span>}</p>
              </div>
            </div>

          </div>
          {/* ))} */}


          {/* <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/explore/top-products/product1.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>Agarbatti <span className='inner_text'>(Rose)</span></p>
                </div>
                
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div> */}

          {/* <div className='product_detail_inner'>
            <div className='left_side'>
              <div className='img_holder'>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/explore/top-products/product2.png"
                  }
                />
              </div>

              <div className='text_holder'>
                <div className='product_name'>
                  <p>Rudraksh  <span className='inner_text'>(5 Faces)</span></p>
                </div>
              </div>
            </div>

            <div>
              <div className='qty_holder'>
                <p>x 1 {!dontShowPrice && <span className='price'>₹ 120</span>}</p>
              </div>
            </div>

          </div> */}
        </div>
      </div>
    </>
  )
}

export default Order_Cancel_Details_Table
